import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import * as LDClient from 'ldclient-js';
import './FeatureFlagContainer.css'; // a single item in the featureFlags array

var FeatureFlagContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(FeatureFlagContainer, _React$Component);

  function FeatureFlagContainer(props) {
    var _this;

    _classCallCheck(this, FeatureFlagContainer);

    var clientId = props.clientId,
        user = props.user;

    if (!(user && user.key)) {
      throw new Error('user is required and must have at least a key property');
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeatureFlagContainer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "client", void 0);

    _this.client = LDClient.initialize(clientId, user);

    _this.client.on('ready', _this.updateFeatureFlags.bind(_assertThisInitialized(_this)));

    _this.client.on('change', _this.updateFeatureFlags.bind(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(FeatureFlagContainer, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(prevProps) {
        var prevUser, user;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                prevUser = prevProps.user;
                user = this.props.user;

                if (!(prevUser !== user)) {
                  _context.next = 12;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return this.client.identify(user, undefined);

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);
                console.error('Error updating user', _context.t0);

              case 11:
                this.updateFeatureFlags();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8]]);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "updateFeatureFlags",
    value: function updateFeatureFlags() {
      var _this2 = this;

      var _this$props = this.props,
          featureFlags = _this$props.featureFlags,
          updateFeatureFlagsCallback = _this$props.updateFeatureFlagsCallback;

      if (!updateFeatureFlagsCallback) {
        return;
      }

      if (Array.isArray(featureFlags) && featureFlags.length) {
        updateFeatureFlagsCallback(featureFlags.reduce(function (current, featureFlag) {
          current[featureFlag.flagName] = _this2.client.variation(featureFlag.ldName, false);
          return current;
        }, {}));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "feature-flag-container viewport"
      }, this.props.children);
    }
  }]);

  return FeatureFlagContainer;
}(React.Component);

export { FeatureFlagContainer as default };